import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React, { useEffect } from "react";

interface FormProps {
  data: Record<string, any>;
  updateData: (data: Record<string, any>) => void;
  validateForm: (isValid: boolean) => void;
}

export default function ThirdForm({ data, updateData, validateForm }: FormProps) {
  const [selectedOption, setSelectedOption] = React.useState(data.equipos || '');

  useEffect(() => {
    // Validar el formulario (verificar que una opción esté seleccionada)
    validateForm(selectedOption !== '');
  }, [selectedOption, validateForm]);

  const handleChange = (e: SelectChangeEvent) => {
    const value = e.target.value as string;
    setSelectedOption(value);
    updateData({ equipos: value });
  };

  return (
    <Box component="form" sx={{ mt: 2, width: {xs:'100%',md:'500px'}, maxWidth: 500 }}>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Equipos a cotizar</InputLabel>
        <Select
          label="Equipos a cotizar"
          value={selectedOption}
          onChange={handleChange}
          fullWidth
          sx={{
            width: '100%',  // Asegura que se ajuste al ancho del contenedor
            '& .MuiInputBase-root': { height: 50 }  // Ajuste de altura
          }}
        >
          <MenuItem value="1 - 5 Equipos">1 - 5 Equipos</MenuItem>
          <MenuItem value="5 - 10 Equipos">5 - 10 Equipos</MenuItem>
          <MenuItem value="10 - 20 Equipos">10 - 20 Equipos</MenuItem>
          <MenuItem value="20 - 50 Equipos">20 - 50 Equipos</MenuItem>
          <MenuItem value="50 o más">50 o más</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
